const setupFileDownload = () => {
  document.querySelectorAll('a[data-file-download]').forEach((link) => {
    link.addEventListener('click', async (event) => {
      event.preventDefault();

      try {
        const response = await fetch(link.href);
        if (!response.ok) throw new Error();

        const url = URL.createObjectURL(await response.blob());
        Object.assign(document.createElement('a'), {
          href: url,
          download: link.download || 'download',
        }).click();
        URL.revokeObjectURL(url);
      } catch {
        window.open(link.href, '_blank', 'noopener');
      }
    });
  });
};

export default setupFileDownload;
